module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":"Public bond issue 2024"},"title":"Public bond issue"},"lt":{"meta":{"title":"Viešas obligacijų platinimas 2024"},"title":"Viešas obligacijų platinimas"}}')
  delete Component.options._Ctor
}
